import Tippy from "@tippyjs/react";
import Loader from "./Loader";
export type Palette = "blue" | "green" | "orange" | "red";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  color: Palette;
  icon: React.ReactNode;
  content?: string;
  type?: "button" | "submit";
  isLoading?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({ label, content, color, icon, type = "submit", isLoading = false, ...props }) => {
  const colors = {
    blue: 'border-blue-500 text-blue-500 hover:bg-blue-500',
    green: 'border-green-500 text-green-500 hover:bg-green-500',
    orange: 'border-orange-500 text-orange-500 hover:bg-orange-500',
    red: 'border-red-500 text-red-500 hover:bg-red-500',
  };

  return (
    <Tippy
      content={
        <div className="p-1 min-w-[30px]">
          {content && (
            <div className="flex items-center justify-center min-h-[80px]">
              {content}
            </div>
          )}
          <div className="text-xs text-center mt-1 text-white">
            {label}
          </div>
        </div>
      }
      placement="top"
      interactive={true}
      delay={[300, 0]}
    >
      <div className="mr-1 hover:text-secondary dark:hover:bg-gray-700 rounded-full transition-colors cursor-pointer">


        <button
          type={type}
          {...props}
          className={`inline-flex items-center justify-center w-10 h-10 rounded-lg border transition-colors duration-200 ${colors[color]} hover:text-white cursor-pointer`}
        >
          {isLoading ? (
            <Loader size="sm" />
          ) : (
            <>{icon}</>
          )}
        </button>
      </div>
    </Tippy>
  );
};

export default IconButton;
